"use strict";

import QRCode from "qrcode";

function clampQrDimension(value, fallback) {
    const parsed = parseInt(value, 10);

    if (Number.isNaN(parsed)) {
        return fallback;
    }

    return Math.max(50, Math.min(500, parsed));
}

function renderQrCodeWrap(wrap) {
    const url = wrap.dataset.url;

    if (!url) {
        return;
    }

    const width = clampQrDimension(wrap.dataset.width, 150);
    const height = clampQrDimension(wrap.dataset.height, 150);
    let canvas = wrap.querySelector("canvas");

    if (!canvas) {
        canvas = document.createElement("canvas");
        canvas.className = "zwssgr-qr-code";
        canvas.setAttribute("role", "img");
        canvas.setAttribute("aria-label", "Scan to leave a Google review");
        wrap.insertBefore(canvas, wrap.firstChild);
    }

    QRCode.toCanvas(canvas, url, {
        width: Math.min(width, height),
        margin: 1,
    }).then(() => {
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
    }).catch((error) => {
        console.error("QR code generation failed:", error);
    });
}

function renderAllQrCodes() {
    document.querySelectorAll(".zwssgr-qr-code-wrap").forEach(renderQrCodeWrap);
}

function toggleQrDimensionsOptions() {
    const toggle = document.getElementById("toggle-qr-code");
    const options = document.getElementById("qr-code-options");

    if (!toggle || !options) {
        return;
    }

    options.style.display = toggle.checked ? "block" : "none";
}

function updateQrPreview() {
    const preview = document.getElementById("qr-code-preview");
    const toggle = document.getElementById("toggle-qr-code");

    if (!preview || !toggle) {
        return;
    }

    if (!toggle.checked || !preview.dataset.reviewUrl) {
        preview.innerHTML = "";
        preview.style.display = "none";
        return;
    }

    const width = clampQrDimension(document.getElementById("qr-code-width")?.value, 150);
    const height = clampQrDimension(document.getElementById("qr-code-height")?.value, 150);

    preview.style.display = "block";
    preview.dataset.url = preview.dataset.reviewUrl;
    preview.dataset.width = String(width);
    preview.dataset.height = String(height);
    preview.classList.add("zwssgr-qr-code-wrap");
    renderQrCodeWrap(preview);
}

document.addEventListener("DOMContentLoaded", function () {
    renderAllQrCodes();

    const toggle = document.getElementById("toggle-qr-code");

    if (!toggle) {
        return;
    }

    toggleQrDimensionsOptions();
    updateQrPreview();

    toggle.addEventListener("change", function () {
        toggleQrDimensionsOptions();
        updateQrPreview();
    });

    ["qr-code-width", "qr-code-height"].forEach((id) => {
        const input = document.getElementById(id);

        if (!input) {
            return;
        }

        input.addEventListener("change", updateQrPreview);
        input.addEventListener("input", updateQrPreview);
    });
});

export { renderAllQrCodes };
